<template>
    <div class="return">
        <router-link :to="{path:'/meeting/details',query:{meeting_id:meeting_id}}">
            <van-icon name="home-o" />
            <span>首页</span>
        </router-link>
        
    </div>
</template>
<script>
export default {
    data(){
        return{
            meeting_id:0
        }
    },
    mounted(){
        this.meeting_id=this.$route.query.meeting_id?this.$route.query.meeting_id:this.$route.query.MT_id;
       
    }
}
</script>
<style lang="scss" scoped>
    .return a{
        display: flex;
        flex-direction: column;;
        align-items: center;
        justify-content: center;
        position: fixed;
        right:10px;
        bottom:20px;
        width:45px;
        height:45px;
        border-radius:100%;
        // border:1px solid #eee;
        box-shadow: 0 0 4px 2px #ccc;
        .van-icon{
            font-size:25px;
            color:$color-main;
        }
        span{
            display: inline-block;
            color:$color-main;
            font-size:12px;
            margin-top:-3px;
        }
    }
    
</style>


// WEBPACK FOOTER //
// src/components/Meeting/Return.vue